/* Serena Laboratories — Main JS */

document.addEventListener('DOMContentLoaded', function () {

function showErrorToast(msg) {
    let t = document.getElementById('serena-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'serena-toast';
      t.style.cssText = [
        'position:fixed','bottom:100px','left:50%','transform:translateX(-50%) translateY(20px)',
        'background:#c0392b','color:#fff','padding:14px 24px','border-radius:100px',
        'font-family:DM Sans,sans-serif','font-size:14px','font-weight:500',
        'box-shadow:0 8px 32px rgba(0,0,0,.25)','z-index:9999',
        'opacity:0','transition:opacity .3s,transform .3s','pointer-events:none'
      ].join(';');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    t.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(t._hide);
    t._hide = setTimeout(() => {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(20px)';
    }, 4000);
  }

/* ── add to cart (AJAX) ── */
  /* NOTE: btn-atc is only used on product pages via their own handlers.
     This global fallback adds to cart and goes to /cart (never /checkout directly)
     so customers always see the cart page before payment. */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn-atc');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) { showErrorToast('Product not available'); return; }

    const hasImg = btn.querySelector('img');
    btn.disabled = true;

    if (hasImg) {
      btn.classList.add('atc-loading');
    } else {
      const orig = btn.textContent;
      btn.textContent = 'Adding…';
      btn._origText = orig;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(data => {
      if (data.status) {
        showErrorToast(data.description || 'Could not add to cart');
      } else {
        /* Go to cart, not checkout — customer must review and choose subscription first */
        window.location.href = '/cart';
      }
    })
    .catch(() => showErrorToast('Something went wrong'))
    .finally(() => {
      btn.disabled = false;
      if (hasImg) {
        btn.classList.remove('atc-loading');
      } else if (btn._origText !== undefined) {
        btn.textContent = btn._origText;
      }
    });
  });

  /* ── hamburger menu ── */
  const ham     = document.getElementById('ham');
  const mobMenu = document.getElementById('mobMenu');
  let isOpen    = false;

  function openMob() {
    isOpen = true;
    ham.classList.add('open');
    mobMenu.classList.add('open');
    ham.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMob() {
    isOpen = false;
    ham.classList.remove('open');
    mobMenu.classList.remove('open');
    ham.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (ham) {
    ham.addEventListener('click', () => isOpen ? closeMob() : openMob());
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMob(); });

  /* ── nav shrink on scroll ── */
  const nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── scroll reveal ── */
  const revObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => revObs.observe(el));

  /* ── sticky bar — always visible ── */

  // Global function to update pricing displays
  window.updateGlobalPricing = function(price, isSubscription, discount) {
    const formatMoney = (cents) => {
      if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
      return '$' + (cents / 100).toFixed(2);
    };

    // Update any sticky price displays
    document.querySelectorAll('[data-dynamic-price]').forEach(el => {
      if (isSubscription) {
        el.textContent = formatMoney(price) + '/mo';
      } else {
        el.textContent = formatMoney(price);
      }
    });

    // Update sticky buttons with price displays
    document.querySelectorAll('.sticky-shop-btn .price-display').forEach(el => {
      if (isSubscription) {
        el.textContent = formatMoney(price) + '/mo';
      } else {
        el.textContent = formatMoney(price);
      }
    });

    console.log('Global pricing updated:', {
      price: formatMoney(price),
      isSubscription: isSubscription,
      discount: discount + '%'
    });
  };

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', function() {
      const answer = this.nextElementSibling;
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      // close all
      document.querySelectorAll('.faq-q').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        b.nextElementSibling.classList.remove('open');
      });
      // open clicked if it was closed
      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        answer.classList.add('open');
      }
    });
  });



});
